import { render, staticRenderFns } from "./NolaNovelSideMenu.vue?vue&type=template&id=09cb1941&scoped=true"
import script from "./NolaNovelSideMenu.vue?vue&type=script&lang=ts"
export * from "./NolaNovelSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelSideMenu.vue?vue&type=style&index=0&id=09cb1941&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cb1941",
  null
  
)

export default component.exports